const {HA_SERP_NUMBER_OF_HITS} = require('../../universal/abacus/experiments');

function resolveNumberOfHits(abacusExperiments) {
    const numberOfHitsExperiment =
        abacusExperiments[HA_SERP_NUMBER_OF_HITS] || {};
    const {bucketValue, bucketConfig} = numberOfHitsExperiment.bucket || {};
    let numberOfHits;

    if (bucketConfig && Number.isInteger(bucketConfig)) {
        numberOfHits = bucketConfig;
    } else if (bucketValue) {
        switch (bucketValue) {
            case 1:
                numberOfHits = 20;
                break;
            case 2:
                numberOfHits = 30;
                break;
            case 3:
                numberOfHits = 75;
                break;
            default:
                break;
        }
    }
    return numberOfHits;
}

module.exports = resolveNumberOfHits;
